import Marquee from "react-fast-marquee";
import { Instagram } from "lucide-react";
import { INSTAGRAM_URL } from "../../lib/constants";

const POSTS = [
  "/photos/t2121.jpg",
  "/photos/t2124.jpg",
  "/photos/g-tattoo-rosa-pescoco.jpg",
  "/photos/t2126.jpg",
  "/photos/t2122.jpg",
  "/photos/g-piercing-septo.jpg",
  "/photos/t2123.jpg",
  "/photos/t2127.jpg",
  "/photos/g-tattoo-floral-borboletas.jpg",
  "/photos/t2130.jpg",
  "/photos/t2129.jpg",
  "/photos/g-piercing-orelha-composicao.jpg",
];

export const InstagramStrip = () => (
  <section className="bg-[#0A0A0A] py-20 border-t border-white/10 overflow-hidden" data-testid="instagram-strip">
    <div className="max-w-7xl mx-auto px-6 mb-10 flex flex-col sm:flex-row sm:items-end justify-between gap-4">
      <div>
        <p className="text-xs tracking-[0.3em] font-bold text-[#E60000] mb-3">NO FEED DA DIGGY</p>
        <h2 className="font-display font-bold text-4xl md:text-5xl text-white leading-none">
          <span className="italic text-[#E60000]">@diggyshop__</span> em movimento
        </h2>
      </div>
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="instagram-follow-button"
        className="btn-sharp inline-flex w-fit items-center gap-2 border border-white/30 hover:border-[#E60000] hover:text-[#E60000] text-white text-xs tracking-[0.15em] font-extrabold px-6 py-4 transition-colors duration-300"
      >
        <Instagram size={14} /> SEGUIR NO INSTAGRAM
      </a>
    </div>

    <Marquee speed={22} gradient={false} pauseOnHover>
      {POSTS.map((src, i) => (
        <a
          key={i}
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`instagram-post-${i}`}
          className="img-frame group relative block w-56 h-56 sm:w-64 sm:h-64 mx-3 border border-white/10 shrink-0"
        >
          <img src={src} alt="Trabalho Diggy Shop no Instagram" loading="lazy" className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0" />
          <div className="absolute inset-0 bg-[#0A0A0A]/0 group-hover:bg-[#E60000]/20 transition-colors duration-500 flex items-center justify-center">
            <Instagram size={22} className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          </div>
        </a>
      ))}
    </Marquee>
  </section>
);
